import { useState } from 'react';
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";

import chevron from '../../constants/images/chevron.svg';
import logo from '../../constants/images/logo.svg';
import { MAIN_ROUTES } from "../../routing/main_routes";
import LinearLoader from "../LinearLoader/LinearLoader";
import UserDetails from "../UserDetails/UserDetails";
import styles from './Header.module.scss';

const Header = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isDropdownActiveOrdersOpen, setIsDropdownActiveOrdersOpen] = useState(false);
    const navigate = useNavigate();
    const {pathname} = useLocation();

    const {status: status1} = useSelector(state => state.userDetails);
    const {status: status2} = useSelector(state => state.order);
    const {status: status3} = useSelector(state => state.cleaningRequests);
    const {status: status4} = useSelector(state => state.servicePackages);
    const {status: status5} = useSelector(state => state.additionalServices);
    const {status: status6} = useSelector(state => state.offer);
    const {status: status7} = useSelector(state => state.serviceTypes);
    const {status: status8} = useSelector(state => state.cleanerApplications);
    const {isPreviewOpen} = useSelector(state => state.modalPreviewSelectedPhoto);

    const isUser = JSON.parse(localStorage.getItem('token'))?.access;
    const isCleaner = JSON.parse(localStorage.getItem('isCleaner'));

    const [isActive, setIsActive] = useState(false);
    const isMinWidth = useMediaQuery({minDeviceWidth: 769});

    const isLoading = status1 === 'loading' || status2 === 'loading' ||
        status3 === 'loading' || status4 === 'loading' || status5 === 'loading' ||
        status6 === 'loading' || status7 === 'loading' || status8 === 'loading';

    const clickHandler = () => {
        setIsActive(!isActive);
    };

    const handleNavigate = (path) => {
        navigate(path);

        // if user click on link in mobile version, then close mobile menu
        setIsActive(false);

        if (isDropdownOpen) {
            setIsDropdownOpen(false);
        }
        if (isDropdownActiveOrdersOpen) {
            setIsDropdownActiveOrdersOpen(false);
        }
    }

    return (
        <>
            <header className={`${styles.header} ${isPreviewOpen ? styles.transparent : ''}`}>
                <div className={styles.header_container}>
                    <div className={`${styles.header_container_leftSide} ${!isUser ? styles.unauthorized : ''}`}>
                        <div
                            onClick={() => isUser ? handleNavigate(isCleaner ? MAIN_ROUTES.ALL_CLEANING_REQUESTS : MAIN_ROUTES.MAIN) : null}
                            className={styles.header_container_leftSide_logo}
                        >
                            <img src={logo} alt="quality cleaning"/>
                        </div>

                        {isUser ?
                            <ul className={styles.header_container_leftSide_list}>
                                <li
                                    className={styles.header_container_leftSide_list_item}
                                >
                                    {isCleaner ?
                                        <div className={styles.header_container_leftSide_list_item_dropdown}>
                                            <p
                                                style={{ color: (pathname === MAIN_ROUTES.ALL_CLEANING_REQUESTS || pathname === MAIN_ROUTES.CLEANER_APPLICATIONS) ? "#405BD8" : "inherit" }}
                                            >Пошук Замовлень</p>
                                            <img src={chevron} alt="chevron"/>
                                        </div> :
                                        <li style={{color: pathname === MAIN_ROUTES.MAIN ? "#405BD8" : "#1C1C1C"}} onClick={() => navigate(MAIN_ROUTES.MAIN)}>Замовлення</li>}
                                    {isCleaner &&
                                        <ul className={styles.dropdownContent}>
                                            <li style={{ color: (pathname === MAIN_ROUTES.ALL_CLEANING_REQUESTS) ? "#405BD8" : "inherit" }} onClick={() => navigate(MAIN_ROUTES.ALL_CLEANING_REQUESTS)}>Пошук Замовлень
                                            </li>
                                            <li style={{ color: (pathname === MAIN_ROUTES.CLEANER_APPLICATIONS) ? "#405BD8" : "inherit" }} onClick={() => navigate(MAIN_ROUTES.CLEANER_APPLICATIONS)}>Подані
                                                заявки
                                            </li>
                                        </ul>}
                                </li>
                                {isCleaner ?
                                    <>
                                        <li
                                            className={styles.header_container_leftSide_list_item}
                                        >
                                    
                                        <div onClick={() => navigate(MAIN_ROUTES.ORDERS)} className={styles.header_container_leftSide_list_item_dropdown}>
                                            <p style={{ color: (pathname === MAIN_ROUTES.ORDERS || pathname === MAIN_ROUTES.COMPLETED_ORDERS) ? "#405BD8" : "inherit" }}>Активні Замовлення</p>
                                            <img src={chevron} alt="chevron"/>
                                        </div> 
                                        {isCleaner &&
                                            <ul className={styles.dropdownContent}>
                                                <li style={{ color: (pathname === MAIN_ROUTES.ORDERS) ? "#405BD8" : "inherit" }} onClick={() => navigate(MAIN_ROUTES.ORDERS)}>Активні Замовлення
                                                </li>
                                                <li style={{ color: (pathname === MAIN_ROUTES.COMPLETED_ORDERS) ? "#405BD8" : "inherit" }} onClick={() => navigate(MAIN_ROUTES.COMPLETED_ORDERS)}>Виконані Замовлення
                                                </li>
                                            </ul>}
                                        </li>
                                    </> :
                                    <>
                                        <li className={`${styles.header_container_leftSide_list_item} ${styles.inProcess}`}>Клінери</li>
                                        <li className={`${styles.header_container_leftSide_list_item} ${styles.inProcess}`}>Бонуси</li>
                                    </>}
                                <li
                                    onClick={() => navigate(MAIN_ROUTES.SETTINGS)}
                                    className={pathname === MAIN_ROUTES.SETTINGS ? styles.header_container_leftSide_list_itemActive : styles.header_container_leftSide_list_item}
                                >Параметри
                                </li>
                            </ul> :
                            <div className={styles.header_container_leftSide_buttons}>
                                <button
                                    onClick={() => navigate(MAIN_ROUTES.LOGIN)}
                                    className={styles.header_container_leftSide_buttons_login}
                                >Увійти
                                </button>
                                <button
                                    onClick={() => navigate(MAIN_ROUTES.REGISTRATION_CLEANER)}
                                    className={styles.header_container_leftSide_buttons_registration}
                                >Я Клінер
                                </button>
                            </div>}
                    </div>

                    {isUser &&
                        <>
                            {isMinWidth && <UserDetails handleNavigate={handleNavigate}/>}
                            <div
                                onClick={clickHandler}
                                className={styles.hamburgerContainer}>
                                <button className={`${styles.hamburger} ${isActive ? styles.isActive : ''}`}>
                                    <div className={styles.bar}></div>
                                </button>
                            </div>
                        </>}
                </div>
                {isLoading && <LinearLoader/>}
            </header>

            {isUser ?
                <div className={`${styles.headerMobileContainer} ${isActive ? styles.isActive : ''}`}>
                    <ul className={styles.headerMobileContainer_list}>
                        <li className={styles.headerMobileContainer_list_item}>
                            <div
                                onClick={() => {
                                    setIsDropdownOpen(prev => !prev);
                                    !isCleaner && handleNavigate(MAIN_ROUTES.MAIN);
                                }}
                            >
                                <p style={{color: (pathname === MAIN_ROUTES.ALL_CLEANING_REQUESTS || pathname===MAIN_ROUTES.CLEANER_APPLICATIONS || pathname === MAIN_ROUTES.MAIN) ? "#405BD8" : "inherit"}}>{isCleaner ? 'Пошук Замовлень' : 'Замовлення'}</p>
                                <img className={(isCleaner && isDropdownOpen) ? styles.open : ''} src={chevron}
                                     alt="chevron right icon"/>
                            </div>
                            {(isCleaner && isDropdownOpen) &&
                                <ul className={styles.headerMobileContainer_list_item_dropdown}>
                                    <li style={{color: pathname === MAIN_ROUTES.ALL_CLEANING_REQUESTS ? "#405BD8" : "inherit"}} onClick={() => handleNavigate(MAIN_ROUTES.ALL_CLEANING_REQUESTS)}>Пошук Замовлень</li>
                                    <li style={{color: pathname === MAIN_ROUTES.CLEANER_APPLICATIONS ? "#405BD8" : "inherit"}} onClick={() => handleNavigate(MAIN_ROUTES.CLEANER_APPLICATIONS)}>Подані заявки
                                    </li>
                                </ul>}
                        </li>
                        {
                            isCleaner ?
                                <>
                        <li className={styles.headerMobileContainer_list_item}>
                            <div
                                onClick={() => {
                                    setIsDropdownActiveOrdersOpen(prev => !prev);
                                    !isCleaner && handleNavigate(MAIN_ROUTES.MAIN);
                                }}
                            >
                                <p style={{color: (pathname === MAIN_ROUTES.ORDERS || pathname===MAIN_ROUTES.COMPLETED_ORDERS) ? "#405BD8" : "inherit"}}>{isCleaner ? 'Активні Замовлення' : 'Замовлення'}</p>
                                <img className={(isCleaner && isDropdownActiveOrdersOpen) ? styles.open : ''} src={chevron}
                                     alt="chevron right icon"/>
                            </div>
                            {(isCleaner && isDropdownActiveOrdersOpen) &&
                                <ul className={styles.headerMobileContainer_list_item_dropdown}>
                                    <li style={{color: pathname === MAIN_ROUTES.ORDERS ? "#405BD8" : "inherit"}} onClick={() => handleNavigate(MAIN_ROUTES.ORDERS)}>Активні Замовлення</li>
                                    <li style={{color: pathname === MAIN_ROUTES.COMPLETED_ORDERS ? "#405BD8" : "inherit"}} onClick={() => handleNavigate(MAIN_ROUTES.COMPLETED_ORDERS)}>Виконані Замовлення
                                    </li>
                                </ul>}
                        </li>
                                </> :
                                <>
                                    <li className={styles.headerMobileContainer_list_item}>
                                        <div>
                                            <p className={styles.inProcess}>Клінери (У розробці)</p>
                                            <img src={chevron} alt="chevron right icon"/>
                                        </div>
                                    </li>
                                    <li className={styles.headerMobileContainer_list_item}>
                                        <div>
                                            <p className={styles.inProcess}>Бонуси (У розробці)</p>
                                            <img src={chevron} alt="chevron right icon"/>
                                        </div>
                                    </li>
                                </>
                        }
                        <li className={styles.headerMobileContainer_list_item}>
                            <div onClick={() => handleNavigate(MAIN_ROUTES.SETTINGS)}>
                                <p style={{color: pathname === MAIN_ROUTES.SETTINGS ? "#405BD8" : "inherit"}}>Параметри</p>
                                <img src={chevron} alt="chevron right icon"/>
                            </div>
                        </li>
                    </ul>

                    <UserDetails handleNavigate={handleNavigate} dropUp/>
                </div> : null}
        </>
    );
};

export default Header;